import { $api } from '../y/api';
import { makeDataStore } from '../y/data-store';
import { $http } from '../y/http';
import { YLanguage } from '../y/i18n';
import { YId, YTimeString } from '../y/types';
import { CEventId } from './c-event';
import { CProducerId } from './c-producer';

export interface VSubtitle {
    language: YLanguage;
}

export interface VRendition {
    id: YId;
    bandwidth: number;
    frame_rate: number;
    width: number;
    height: number;
}

export type VVideoStatus = 'created' | 'playable' | 'complete';

export interface VVideo {
    id: YId;
    name: string;
    status: VVideoStatus;
    duration: number;
    created_at: YTimeString;

    producer_id?: CProducerId;
    event_id?: CEventId;
    master_url: string;

    renditions: VRendition[];
    subtitles: VSubtitle[];
}

export const v_videos = makeDataStore('v/videos', 'v/video', (m: VVideo) => m, Object.assign);

export function vVideoUploadFile(name: string, file: File, progress?: (p: number) => void) {
    const url_base = '/service/media/v1/video_upload';

    return $http.POST(url_base, file, { aux: { name: name }, up_progress: progress }).catch($api.errorHandler);
}
